export const pathMappings = {
  // Booking
  'booking-confirmation': 'termin-bestaetigung',
  
  // Solutions
  'solutions/ai-consulting': 'solutions/ki-beratung',
  'solutions/automatisation': 'solutions/automatisierung',
  'solutions/industry-4-0': 'solutions/industrie-4-0',
  
  // Main pages
  'contact': 'kontakt',
  'privacy': 'datenschutz',
  'legal': 'impressum',
  
  // Add more mappings as needed
} as const;

export type PathMapping = typeof pathMappings;

import { getPostFromWordPress, getPostSlugById } from "@/lib/wordpress";

export async function getTranslatedPath(path: string, fromLocale: 'en' | 'de'): Promise<string> {
  // Entferne führenden Slash wenn vorhanden
  const cleanPath = path.startsWith('/') ? path.slice(1) : path;
  
  // Prüfe ob es ein Blog-Artikel ist
  if (cleanPath.startsWith('blog/')) {
    const slug = cleanPath.replace('blog/', '');
    
    // Hole den Post mit dem Slug
    const post = await getPostFromWordPress(slug, fromLocale);
    if (!post?.translations) {
      return 'blog'; // Wenn keine Übersetzungen, zur Blog-Übersicht
    }
    
    // Hole die ID der Übersetzung
    const targetLocale = fromLocale === 'en' ? 'de' : 'en';
    const translatedId = post.translations[targetLocale];
    
    if (translatedId) {
      // Hole den Slug für die übersetzte Version
      const translatedSlug = await getPostSlugById(translatedId);
      if (translatedSlug) {
        return `blog/${translatedSlug}`;
      }
    }
    
    return 'blog'; // Fallback: zur Blog-Übersicht
  }
  
  // Für alle anderen Pfade: bisherige Logik
  if (fromLocale === 'en') {
    // Suche nach englischem Pfad und gib deutschen zurück
    for (const [enPath, dePath] of Object.entries(pathMappings)) {
      if (cleanPath === enPath) {
        return dePath;
      }
    }
  } else {
    // Suche nach deutschem Pfad und gib englischen zurück
    for (const [enPath, dePath] of Object.entries(pathMappings)) {
      if (cleanPath === dePath) {
        return enPath;
      }
    }
  }
  
  // Wenn kein spezielles Mapping gefunden wurde, gib den originalen Pfad zurück
  return cleanPath;
}
